import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import "react";
import { useProps } from "./auth-service-tools225.js";
import { Box } from "./auth-service-tools244.js";
import { factory } from "./auth-service-tools248.js";
import { useMenuContext } from "./auth-service-tools376.js";
import classes from "./auth-service-tools382.js";
const defaultProps = {};
const MenuLabel = factory((props, ref) => {
  const {
    classNames,
    className,
    style,
    styles,
    vars,
    ...others
  } = useProps("MenuLabel", defaultProps, props);
  const ctx = useMenuContext();
  return /* @__PURE__ */jsxRuntimeExports.jsx(Box, {
    ref,
    ...ctx.getStyles("label", {
      className,
      style,
      styles,
      classNames
    }),
    ...others
  });
});
MenuLabel.classes = classes;
MenuLabel.displayName = "@mantine/core/MenuLabel";
export { MenuLabel };